import axios from "@/libs/api.request";
// 获取列表
export const getBranchFreight = params => {
  return axios.request({
    url: "/user/companyFreight/bind",
    params,
    method: "get"
  });
};

export const getCompanyConfig = () => {
  return axios.request({
    url: `/user/companyFreight/config`,
    method: "get"
  });
};

export const addBranchFreight = data => {
  return axios.request({
    url: `/user/companyFreight/bind`,
    data,
    method: "post"
  });
};

export const getAuditLog = id => {
  return axios.request({
    url: `/user/companyFreight/readAuditLog/${id}`,
    method: "get"
  });
};

export const saveAudit = data => {
  return axios.request({
    url: `/user/companyFreight/handleAudit/${data.id}`,
    method: "post",
    data
  });
};

export const batchRemove = data => {
  return axios.request({
    url: `/user/companyFreight/batchRemove`,
    method: "post",
    data
  });
};


export const getCountryFreight = params => {
  return axios.request({
    url: `/user/companyFreight/quotation`,
    method: "get",
    params
  });
};

